import React from 'react';

import {ReactComponent as burgerMenu} from './burgerMenu.svg';
import {ReactComponent as info} from './info.svg';
import {ReactComponent as calendar} from './calendar.svg';
import {ReactComponent as check} from './check.svg';
import {ReactComponent as close} from './close.svg';
import {ReactComponent as profile} from './profile.svg';
import {ReactComponent as profileVisImp} from './profileVisImp.svg';
import {ReactComponent as logoVisImp} from './logoVisImp_v02.svg';
import {ReactComponent as eye} from './eye.svg';
import {ReactComponent as eyeOff} from './eyeOff.svg';
import {ReactComponent as eyeFat} from './eyeFat.svg';
import {ReactComponent as eyeOffFat} from './eyeOffFat.svg';
import {ReactComponent as eraseKey} from './eraseKey_v01.svg';
import {ReactComponent as cards} from './cards.svg';
import {ReactComponent as cardsOutline} from './cardsOutline.svg';

import {ReactComponent as checkRound} from './checkRound.svg';
import {ReactComponent as notCheckRound} from './notCheckRound.svg';
import {ReactComponent as chevronRight} from './chevronRight.svg';
import {ReactComponent as help} from './help.svg';
import {ReactComponent as list} from './list-with-bullets.svg';
import {ReactComponent as mapPoint} from './mapPoint.svg';
import {ReactComponent as lock} from './lock.svg';
import {ReactComponent as signOut} from './signout_v01.svg';
import {ReactComponent as question} from './question.svg';
import {ReactComponent as qrCode} from './qrCode3.svg';
import {ReactComponent as right} from './right.svg';
import {ReactComponent as esia} from './esia.svg';
import {ReactComponent as left} from './left.svg';
import {ReactComponent as noInternet} from './noInternet.svg';
import {ReactComponent as burger} from './burger.svg';
import {ReactComponent as transport} from './services/transport.svg';
import {ReactComponent as banking} from './services/banking.svg';
import {ReactComponent as privileges} from './services/privileges.svg';
import {ReactComponent as babyFood} from './services/babyFood.svg';
import {ReactComponent as loyalty} from './services/loyalty.svg';
import {ReactComponent as socialSupport} from './services/socialSupport.svg';
import {ReactComponent as eCertificate} from './services/eCertificate.svg';
import {ReactComponent as tracery1} from './services/tracery1.svg';
import {ReactComponent as tracery2} from './services/tracery2.svg';
import {ReactComponent as tracery3} from './services/tracery3.svg';
import {ReactComponent as tracery5} from './services/tracery5.svg';
import {ReactComponent as tracery6} from './services/tracery6.svg';
import {ReactComponent as loyaltyAcceptorCardTracery} from './shapes/loyaltyAcceptorCardTracery.svg';
import {ReactComponent as checkMark} from './check-mark.svg';
import {ReactComponent as checkOn} from './checkOn.svg';
import {ReactComponent as checkOff} from './checkOff.svg';
import {ReactComponent as checkInter} from './checkInter.svg';
import {ReactComponent as tracery4} from './services/tracery4.svg';
import {ReactComponent as privilegeCardPattern} from './privileges/privilege-card-pattern.svg';
import {ReactComponent as privilegeCardPatternMobile} from './privileges/privilege-card-pattern-mobile.svg';
import {ReactComponent as privilegeSuccessPattern} from './privileges/privilege-success-pattern.svg';
import {ReactComponent as privilegeSuccessPatternMobile} from './privileges/privilege-success-pattern-mobile.svg';
import {ReactComponent as serviceDetailsPattern} from './service-details-pattern.svg';
import {ReactComponent as serviceDetailsPatternMobile} from './service-details-pattern-mobile.svg';
import {ReactComponent as Pencil} from './pencil.svg';
import {ReactComponent as phone} from './phone_v01.svg';
import {ReactComponent as email} from './email.svg';
import {ReactComponent as globe} from './globe.svg';
import {ReactComponent as refresh} from './refresh.svg';
import {ReactComponent as socialSupportButtonPattern} from './services/socialSupportButtonPattern.svg';
import {ReactComponent as Clock} from './clock.svg';
import {ReactComponent as ShapesCircleShadow} from './shapes/circleShadow.svg';
import {ReactComponent as ShapesCircle} from './shapes/circle.svg';
import {ReactComponent as ShapesPollsBg} from './shapes/polls-bg.svg';
import {ReactComponent as up} from './upThin_v01.svg';
import {ReactComponent as chevronLeft} from './chevron-left.svg';
import {ReactComponent as ServiceCardTracery} from './shapes/serviceCardTracery.svg';
import {ReactComponent as PhoneFill} from './phoneFill.svg';
import {ReactComponent as plus} from './plus.svg';
import {ReactComponent as plusInCircle} from './plusInCircle.svg';
import {ReactComponent as Clip} from './clip.svg';
import {ReactComponent as Exclamation} from './exclamation.svg';
import {ReactComponent as checkInCircle} from './checkInCircle.svg';
import {ReactComponent as questionInTriangle} from './questionInTriangle.svg';
import {ReactComponent as SurveySuccessBg} from './shapes/survey-success-bg.svg';
import {ReactComponent as SurveySuccessBgMobile} from './shapes/survey-success-bg-mobile.svg';
import {ReactComponent as Filter} from './filter.svg';
import {ReactComponent as Fingerprint} from './fingerprint.svg';
import {ReactComponent as Search} from './search.svg';
import {ReactComponent as chevronDown} from './chevronDown.svg';
import {ReactComponent as chevronUp} from './chevronUp.svg';
import {ReactComponent as chevronUpDropdown} from './chevron-up-dropdown.svg';
import {ReactComponent as heart} from './heart.svg';
import {ReactComponent as campusKey} from './campusKey.svg';

import {ReactComponent as userOutlined24} from './userOutlined24.svg';
import {ReactComponent as userOutlined36} from './userOutlined36.svg';
import {ReactComponent as userOutlined100} from './userOutlined100.svg';
import {ReactComponent as userOutlined160} from './userOutlined160.svg';

import {ReactComponent as AcceptorMap} from './shapes/acceptor-map-shape.svg';
import {ReactComponent as Clock2} from './clock2.svg';
import {ReactComponent as Location} from './location.svg';
import {ReactComponent as MapMarker} from './map-marker.svg';
import {ReactComponent as MapPin} from './map-pin.svg';

import {ReactComponent as SocialVk} from './socials/vk.svg';
import {ReactComponent as SocialFacebook} from './socials/facebook.svg';
import {ReactComponent as SocialInstagram} from './socials/instagram.svg';
import {ReactComponent as SocialOk} from './socials/ok.svg';
import {ReactComponent as SocialTelegram} from './socials/telegram.svg';

import {ReactComponent as arrowDown} from './arrowDown.svg';
import {ReactComponent as arrowDown2} from './arrowDown2.svg';
import {ReactComponent as arrowDownWide} from './arrowDownWide.svg';
import {ReactComponent as arrowUp} from './arrowUp.svg';

import {ReactComponent as TabBarCircle} from './tabbar/tabbar-circle.svg';
import {ReactComponent as TabBarCircleRight} from './tabbar/tabbar-circle-right.svg';
import {ReactComponent as TabBarCard} from './tabbar/tabbar-card.svg';

import {ReactComponent as TabBarHome} from './tabbar/tabbar-home.svg';
import {ReactComponent as TabBarMenu} from './tabbar/tabbar-menu.svg';
import {ReactComponent as TabBarSupport} from './tabbar/tabbar-support.svg';
import {ReactComponent as TabBarPossibilities} from './tabbar/tabbar-possibilities.svg';

import {ReactComponent as Loader1} from './loader/1.svg';
import {ReactComponent as Loader2} from './loader/2.svg';
import {ReactComponent as Loader3} from './loader/3.svg';
import {ReactComponent as Loader4} from './loader/4.svg';
import {ReactComponent as Loader5} from './loader/5.svg';
import {ReactComponent as Loader6} from './loader/6.svg';
import {ReactComponent as Loader7} from './loader/7.svg';
import {ReactComponent as Loader8} from './loader/8.svg';
import {ReactComponent as Loader9} from './loader/9.svg';
import {ReactComponent as Loader10} from './loader/10.svg';
import {ReactComponent as Loader11} from './loader/11.svg';
import {ReactComponent as Loader12} from './loader/12.svg';
import {ReactComponent as Loader13} from './loader/13.svg';
import {ReactComponent as Loader14} from './loader/14.svg';
import {ReactComponent as Loader15} from './loader/15.svg';
import {ReactComponent as Loader16} from './loader/16.svg';
import {ReactComponent as Loader17} from './loader/17.svg';
import {ReactComponent as Loader18} from './loader/18.svg';
import {ReactComponent as Loader19} from './loader/19.svg';
import {ReactComponent as Loader20} from './loader/20.svg';
import {ReactComponent as Loader21} from './loader/21.svg';
import {ReactComponent as Loader22} from './loader/22.svg';
import {ReactComponent as Loader23} from './loader/23.svg';
import {ReactComponent as Loader24} from './loader/24.svg';
import {ReactComponent as Loader25} from './loader/25.svg';
import {ReactComponent as Loader26} from './loader/26.svg';
import {ReactComponent as Loader27} from './loader/27.svg';
import {ReactComponent as Loader28} from './loader/28.svg';
import {ReactComponent as Loader29} from './loader/29.svg';
import {ReactComponent as Loader30} from './loader/30.svg';
import {ReactComponent as Loader31} from './loader/31.svg';
import {ReactComponent as Loader32} from './loader/32.svg';
import {ReactComponent as Loader33} from './loader/33.svg';
import {ReactComponent as Loader34} from './loader/34.svg';
import {ReactComponent as Loader35} from './loader/35.svg';
import {ReactComponent as Loader36} from './loader/36.svg';
import {ReactComponent as Loader37} from './loader/37.svg';

import {SvgHoc} from '../../shared/components/svg';
import {IconProps} from '../../shared/components/svg/model';

import {ReactComponent as volunteers} from './services/volunteers.svg';
import {ReactComponent as DobroRuLogo} from './dobroruLogo.svg';
import {ReactComponent as helpQuestion} from './helpQuestion.svg';

import {ReactComponent as rewardShop} from '../../assets/icons/services/rewardShop.svg';
import {ReactComponent as funnel} from './funnel.svg';
import {ReactComponent as basket} from './basket.svg';
import {ReactComponent as pointsStart} from './pointsStar.svg';

import {ReactComponent as ekarta} from './eKarta.svg';
import {ReactComponent as frisbi} from './frisbi.svg';
import {ReactComponent as ekartaBlack} from './eKartaBlack.svg';
import {ReactComponent as frisbiBlack} from './frisbiBlack.svg';

import {ReactComponent as cashback} from './cashback.svg';
import {ReactComponent as download} from './download.svg';
import {ReactComponent as download2} from './downLoad_2.svg';

import {ReactComponent as skipass} from './services/skipass.svg';

import {ReactComponent as chatbot} from './chatbot.svg';
import {ReactComponent as technicalWork} from './technicalWork.svg';
import {ReactComponent as user} from './user.svg';
import {ReactComponent as sendMessage} from './send-message.svg';

export type IconSvg = React.FC<IconProps>;

export const images = {
  BurgerMenu: SvgHoc({source: burgerMenu}),
  Info: SvgHoc({source: info}),
  Profile: SvgHoc({source: profile}),
  ProfileVisImp: SvgHoc({source: profileVisImp}),
  LogoVisImp: SvgHoc({source: logoVisImp}),
  Eye: SvgHoc({source: eye}),
  EyeFat: SvgHoc({source: eyeFat}),
  EyeOff: SvgHoc({source: eyeOff}),
  EyeOffFat: SvgHoc({source: eyeOffFat}),
  EraseKey: SvgHoc({source: eraseKey}),
  Cards: SvgHoc({source: cards}),
  CardsOutline: SvgHoc({source: cardsOutline}),
  ChevronRight: SvgHoc({source: chevronRight}),
  Help: SvgHoc({source: help}),
  List: SvgHoc({source: list}),
  MapPoint: SvgHoc({source: mapPoint}),
  Lock: SvgHoc({source: lock}),
  SignOut: SvgHoc({source: signOut}),
  Question: SvgHoc({source: question}),
  QrCode: SvgHoc({source: qrCode}),
  Transport: SvgHoc({source: transport}),
  Banking: SvgHoc({source: banking}),
  Privileges: SvgHoc({source: privileges}),
  Loyalty: SvgHoc({source: loyalty}),
  BabyFood: SvgHoc({source: babyFood}),
  SocialSupport: SvgHoc({source: socialSupport}),
  Tracery1: SvgHoc({source: tracery1}),
  Tracery2: SvgHoc({source: tracery2}),
  Tracery3: SvgHoc({source: tracery3}),
  Tracery4: SvgHoc({source: tracery4}),
  Tracery5: SvgHoc({source: tracery5}),
  Tracery6: SvgHoc({source: tracery6}),
  LoyaltyAcceptorCardTracery: SvgHoc({source: loyaltyAcceptorCardTracery}),
  Right: SvgHoc({source: right}),
  Left: SvgHoc({source: left}),
  NoInternet: SvgHoc({source: noInternet}),
  Burger: SvgHoc({source: burger}),
  Check: SvgHoc({source: check}),
  Close: SvgHoc({source: close}),
  Phone: SvgHoc({source: phone}),
  Email: SvgHoc({source: email}),
  CheckMark: SvgHoc({source: checkMark}),
  checkOn: SvgHoc({source: checkOn}),
  checkOff: SvgHoc({source: checkOff}),
  checkInter: SvgHoc({source: checkInter}),
  Pencil: SvgHoc({source: Pencil}),
  Globe: SvgHoc({source: globe}),
  Refresh: SvgHoc({source: refresh}),
  ServiceDetailsPattern: SvgHoc({source: serviceDetailsPattern}),
  ServiceDetailsPatternMobile: SvgHoc({source: serviceDetailsPatternMobile}),
  SocialSupportButtonPattern: SvgHoc({source: socialSupportButtonPattern}),
  PrivilegeCardPattern: SvgHoc({source: privilegeCardPattern}),
  PrivilegeCardPatternMobile: SvgHoc({source: privilegeCardPatternMobile}),
  PrivilegeSuccessPatternMobile: SvgHoc({source: privilegeSuccessPatternMobile}),
  PrivilegeSuccessPattern: SvgHoc({source: privilegeSuccessPattern}),
  NotCheckRound: SvgHoc({source: notCheckRound}),
  CheckRound: SvgHoc({source: checkRound}),
  ShapesCircleShadow: SvgHoc({source: ShapesCircleShadow}),
  ShapesCircle: SvgHoc({source: ShapesCircle}),
  Clock: SvgHoc({source: Clock}),
  Clock2: SvgHoc({source: Clock2}),
  Location: SvgHoc({source: Location}),
  MapMarker: SvgHoc({source: MapMarker}),
  MapPin: SvgHoc({source: MapPin}),
  Up: SvgHoc({source: up}),
  ArrowDown: SvgHoc({source: arrowDown}),
  ArrowDown2: SvgHoc({source: arrowDown2}),
  ArrowDownWide: SvgHoc({source: arrowDownWide}),
  ArrowUp: SvgHoc({source: arrowUp}),
  ChevronLeft: SvgHoc({source: chevronLeft}),
  ServiceCardTracery: SvgHoc({source: ServiceCardTracery}),
  PhoneFill: SvgHoc({source: PhoneFill}),
  Plus: SvgHoc({source: plus}),
  PlusInCircle: SvgHoc({source: plusInCircle}),
  ShapesPollsBg: SvgHoc({source: ShapesPollsBg}),
  Clip: SvgHoc({source: Clip}),
  Exclamation: SvgHoc({source: Exclamation}),
  CheckInCircle: SvgHoc({source: checkInCircle}),
  AcceptorMap: SvgHoc({source: AcceptorMap}),
  QuestionInTriangle: SvgHoc({source: questionInTriangle}),
  Search: SvgHoc({source: Search}),
  SocialVk: SvgHoc({source: SocialVk}),
  SocialFacebook: SvgHoc({source: SocialFacebook}),
  SocialInstagram: SvgHoc({source: SocialInstagram}),
  SocialOk: SvgHoc({source: SocialOk}),
  SocialTelegram: SvgHoc({source: SocialTelegram}),
  SurveySuccessBg: SvgHoc({source: SurveySuccessBg}),
  SurveySuccessBgMobile: SvgHoc({source: SurveySuccessBgMobile}),
  TabBarPossibilities: SvgHoc({source: TabBarPossibilities}),
  TabBarCircle: SvgHoc({source: TabBarCircle}),
  TabBarCircleRight: SvgHoc({source: TabBarCircleRight}),
  TabBarHome: SvgHoc({source: TabBarHome}),
  TabBarCard: SvgHoc({source: TabBarCard}),
  TabBarMenu: SvgHoc({source: TabBarMenu}),
  TabBarSupport: SvgHoc({source: TabBarSupport}),
  Filter: SvgHoc({source: Filter}),
  Fingerprint: SvgHoc({source: Fingerprint}),
  Calendar: SvgHoc({source: calendar}),
  ChevronDown: SvgHoc({source: chevronDown}),
  ChevronUp: SvgHoc({source: chevronUp}),
  ChevronUpDropdown: SvgHoc({source: chevronUpDropdown}),
  UserOutlined24: SvgHoc({source: userOutlined24}),
  UserOutlined36: SvgHoc({source: userOutlined36}),
  UserOutlined100: SvgHoc({source: userOutlined100}),
  UserOutlined160: SvgHoc({source: userOutlined160}),
  Loader: [
    SvgHoc({source: Loader1, isNeedModification: true}),
    SvgHoc({source: Loader2, isNeedModification: true}),
    SvgHoc({source: Loader3, isNeedModification: true}),
    SvgHoc({source: Loader4, isNeedModification: true}),
    SvgHoc({source: Loader5, isNeedModification: true}),
    SvgHoc({source: Loader6, isNeedModification: true}),
    SvgHoc({source: Loader7, isNeedModification: true}),
    SvgHoc({source: Loader8, isNeedModification: true}),
    SvgHoc({source: Loader9, isNeedModification: true}),
    SvgHoc({source: Loader10, isNeedModification: true}),
    SvgHoc({source: Loader11, isNeedModification: true}),
    SvgHoc({source: Loader12, isNeedModification: true}),
    SvgHoc({source: Loader13, isNeedModification: true}),
    SvgHoc({source: Loader14, isNeedModification: true}),
    SvgHoc({source: Loader15, isNeedModification: true}),
    SvgHoc({source: Loader16, isNeedModification: true}),
    SvgHoc({source: Loader17, isNeedModification: true}),
    SvgHoc({source: Loader18, isNeedModification: true}),
    SvgHoc({source: Loader19, isNeedModification: true}),
    SvgHoc({source: Loader20, isNeedModification: true}),
    SvgHoc({source: Loader21, isNeedModification: true}),
    SvgHoc({source: Loader22, isNeedModification: true}),
    SvgHoc({source: Loader23, isNeedModification: true}),
    SvgHoc({source: Loader24, isNeedModification: true}),
    SvgHoc({source: Loader25, isNeedModification: true}),
    SvgHoc({source: Loader26, isNeedModification: true}),
    SvgHoc({source: Loader27, isNeedModification: true}),
    SvgHoc({source: Loader28, isNeedModification: true}),
    SvgHoc({source: Loader29, isNeedModification: true}),
    SvgHoc({source: Loader30, isNeedModification: true}),
    SvgHoc({source: Loader31, isNeedModification: true}),
    SvgHoc({source: Loader32, isNeedModification: true}),
    SvgHoc({source: Loader33, isNeedModification: true}),
    SvgHoc({source: Loader34, isNeedModification: true}),
    SvgHoc({source: Loader35, isNeedModification: true}),
    SvgHoc({source: Loader36, isNeedModification: true}),
    SvgHoc({source: Loader37, isNeedModification: true}),
  ],
  Esia: SvgHoc({source: esia, isNeedModification: true}),
  Heart: SvgHoc({source: heart}),
  CampusKey: SvgHoc({source: campusKey}),
  Volunteering: SvgHoc({source: volunteers}),
  DobroRuLogo: SvgHoc({source: DobroRuLogo}),
  HelpQuestion: SvgHoc({source: helpQuestion}),
  RewardShopIcon: SvgHoc({source: rewardShop}),
  Funnel: SvgHoc({source: funnel}),
  Basket: SvgHoc({source: basket}),
  PointsStart: SvgHoc({source: pointsStart}),
  Ekarta: SvgHoc({source: ekarta}),
  Frisbi: SvgHoc({source: frisbi}),
  EkartaBlack: SvgHoc({source: ekartaBlack}),
  FrisbiBlack: SvgHoc({source: frisbiBlack}),
  Cashback: SvgHoc({source: cashback}),
  ECertificates: SvgHoc({source: eCertificate}),
  Download: SvgHoc({source: download}),
  Download2: SvgHoc({source: download2}),
  Skipass: SvgHoc({source: skipass}),
  Chatbot: SvgHoc({source: chatbot}),
  TechnicalWork: SvgHoc({source: technicalWork}),
  User: SvgHoc({source: user}),
  SendMessage: SvgHoc({source: sendMessage}),
};
